import { ChatMessage } from "../../../types/Message.types";
import { StyledImage, StyledMessageBubble } from "../ConversationArea.styled";
import MarkdownLaTeXRenderer from "./MarkdownRenderer";

interface MessageItemProps {
    msg: ChatMessage;
    index: number;
}

const MessageItem: React.FC<MessageItemProps> = ({ index, msg }) => {
    const isUserMessageWithImage = msg.fromUser && msg.imageUrl;
    return (
        <StyledMessageBubble key={index} fromUser={msg.fromUser}>
            <MarkdownLaTeXRenderer content={msg.text} />
            {isUserMessageWithImage  && (
                <StyledImage
                    src={msg.imageUrl}
                    alt="User uploaded content"
                />
            )}
        </StyledMessageBubble>
    );
};

export default MessageItem;
